import SNSLogin from "./snslogin";

$(document).ready(function() {
    if(location.href)

    SNSLogin.init();
    Login.init();
});


var Login = (function() {
    var $formId = $("#form_id");
    var $formPw = $("#form_pw");
    var $btnLogin = $("#btn_login");


    function getParameters(paramName) {
        // 리턴값을 위한 변수 선언
        var returnValue;
    
        // 현재 URL 가져오기
        var url = location.href;
    
        // get 파라미터 값을 가져올 수 있는 ? 를 기점으로 slice 한 후 split 으로 나눔
        var parameters = (url.slice(url.indexOf('?') + 1, url.length)).split('&');
    
        // 나누어진 값의 비교를 통해 paramName 으로 요청된 데이터의 값만 return
        for (var i = 0; i < parameters.length; i++) {
            var varName = parameters[i].split('=')[0];
            if (varName.toUpperCase() == paramName.toUpperCase()) {
                returnValue = parameters[i].split('=')[1];
                return returnValue;
            }
        }
    };

    function init() {
        $btnLogin.on("click", function(e) {
            e.preventDefault();

            $.ajax("/member/_proc/wb_login.php", {
                type: "POST",
                data: {
                    user_id: $formId.val(),
                    password: $formPw.val()
                }
            }).then(
                function(res) {
                    var result = JSON.parse(res);

                    if (result.success === true) {
                        if (/^join+/.test(document.referrer.split("/").pop())) {
                            location.href = "//www.waglebagle.net";
                            return;
                        }
                        var reUrl = getParameters("reUrl");
                        
                        if(reUrl) {
                            location.href = "//www.waglebagle.net" + decodeURIComponent(atob(reUrl));
                        } else if(document.referrer && (document.referrer.indexOf("waglebagle.net") !== -1)){
                            history.back();
                        } else {
                            location.href = "//www.waglebagle.net";
                        }

                    } else {
                        alert(result.message);
                        console.log(result);
                        if (
                            result.data !== null &&
                            result.data.location !== null
                        ) {
                            location.href = result.data.location;
                        }
                    }
                },
                function(err) {
                    alert(err);
                }
            );
        });
    }

    return {
        init: init
    };
})();



// WEBPACK FOOTER //
// ./member/js/login.js